import React, { useState, useEffect } from 'react';
import axiosInstance from '@/apis/axiosInstance';

import { useTranslation } from 'react-i18next';
import { isMobile } from '@/biz/tool';
import { Loading } from 'aha-components';

export default function EmailUnsubscribe() {
  const { t } = useTranslation();
  const email = decodeURIComponent(window.location.search.split('email=')[1]);
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [showResult, setShowResult] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);
  const [unsubscribeLoading, setUnsubscribeLoading] = useState(false);
  const [resubscribeLoading, setResubscribeLoading] = useState(false);

  function safeDecodeBase64(input?: string | null) {
    if (!input) return '';
    try {
      // 去掉空白
      input = input.trim().replace(/\s+/g, '');
      // base64url -> base64
      input = input.replace(/-/g, '+').replace(/_/g, '/');
      // 补齐到 4 的倍数
      if (input.length % 4) {
        input += '='.repeat(4 - (input.length % 4));
      }
      // atob -> bytes -> UTF-8 文本
      const bin = atob(input);
      const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    } catch (e) {
      return '';
    }
  }

  // 获取邮箱订阅状态
  const getEdmStatus = async () => {
    const { data } = await axiosInstance.get(
      `/influencer/edm/status?email=${email}`
    );
    if (data?.code === 0) {
      setIsSubscribed(data?.data?.subscribed);
    }
    setStatusLoading(false);
  };
  useEffect(() => {
    getEdmStatus();
  }, []);

  // 取消邮箱订阅
  const emailUnsubscribeApi = async () => {
    if (unsubscribeLoading) return;
    setUnsubscribeLoading(true);
    const { data } = await axiosInstance.post(
      `/influencer/edm/unsubscribe?email=${email}`
    );
    if (data.code === 0) {
      setIsSubscribed(false);
    }
    setUnsubscribeLoading(false);
  };

  // 订阅邮箱
  const emailResubscribeApi = async () => {
    if (resubscribeLoading) return;
    setResubscribeLoading(true);
    const { data } = await axiosInstance.post(
      `/influencer/edm/subscribe?email=${email}`
    );
    if (data.code === 0) {
      setShowResult(true);
    }
    setResubscribeLoading(false);
  };

  if (statusLoading || !email) {
    return (
      <div className="flex flex-col justify-center items-center h-[calc(100vh)] w-full">
        <Loading width={50} height={50} color="#000" />
        <div className="text-gray-500 text-sm">Loading resources...</div>
      </div>
    );
  }

  return (
    <div className="w-full h-[calc(100vh)] flex items-center justify-center">
      {!showResult && isSubscribed && (
        <div className="text-center">
          <div
            className={`${isMobile() ? 'w-full px-2 text-2xl' : 'w-[966px] text-5xl'} text-center justify-center text-neutral-900 font-medium font-['Bitter']`}
          >
            {t('emailUnsubscribe.subscribeTitle')}
          </div>
          <div
            className={`${isMobile() ? 'w-full px-4 text-sm' : 'w-[966px] text-xl'} mt-3 text-center justify-center text-neutral-500 font-normal font-['DM_Sans'] leading-loose`}
          >
            {t('emailUnsubscribe.subscribeDesc')}{' '}
            {email ? safeDecodeBase64(email) : ''}
          </div>
          <div
            className={`flex justify-center items-center mt-8 ${isMobile() ? 'flex-col-reverse gap-5' : 'gap-5'}`}
          >
            <div
              className={`cursor-pointer px-6 h-[40px] rounded-full flex items-center gap-2 bg-gradient-to-b from-white to-[#E7E5E4] hover:bg-white hover:from-white hover:to-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] w-fit`}
              onClick={() => {
                setShowResult(true);
              }}
            >
              <div className="text-center text-[#121212] text-[16px] font-medium font-['Bitter'] leading-tight tracking-tight whitespace-nowrap">
                {t('emailUnsubscribe.button.waitKeepMeSubscribed')}
              </div>
            </div>
            <div
              className={`cursor-pointer rounded-[20px] font-medium`}
              style={{
                padding: '8px 20px',
                color: '#FFF',
                background: 'linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)',
                boxShadow: `0px 0px 0px 1px #191A1A08,
              0px 1px 1px -0.5px #191A1A08,
              0px 2px 2px -1px #191A1A08,
              0px 4px 4px -2px #191A1A05,
              0px 8px 8px -4px #191A1A05,
              0px 16px 16px -8px #191A1A05`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  'linear-gradient(180deg, #757575 0%, #414141 100%)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  'linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)';
              }}
              onClick={emailUnsubscribeApi}
            >
              {`${t('emailUnsubscribe.button.unsubscribe')}${unsubscribeLoading ? ' ...' : ''}`}
            </div>
          </div>
        </div>
      )}
      {!showResult && !isSubscribed && (
        <div className="text-center">
          <div
            className={`${isMobile() ? 'w-full px-2 text-2xl' : 'w-[926px] text-5xl'} text-center justify-center text-neutral-900 font-medium font-['Bitter']`}
          >
            {t('emailUnsubscribe.cancelTitle')}
          </div>
          <div
            className={`${isMobile() ? 'w-full px-4 text-sm' : 'text-xl'} mt-3 text-center justify-center text-neutral-500 font-normal font-['DM_Sans'] leading-loose`}
          >
            {t('emailUnsubscribe.cancelDesc')}
          </div>
          <div className="mt-8 flex items-center justify-center gap-5">
            <div
              className="cursor-pointer rounded-[20px] font-medium"
              style={{
                padding: '8px 20px',
                color: '#FFF',
                background: 'linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)',
                boxShadow: `0px 0px 0px 1px #191A1A08,
              0px 1px 1px -0.5px #191A1A08,
              0px 2px 2px -1px #191A1A08,
              0px 4px 4px -2px #191A1A05,
              0px 8px 8px -4px #191A1A05,
              0px 16px 16px -8px #191A1A05`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  'linear-gradient(180deg, #757575 0%, #414141 100%)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  'linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)';
              }}
              onClick={emailResubscribeApi}
            >
              {`${t('emailUnsubscribe.button.resubscribe')}${resubscribeLoading ? ' ...' : ''}`}
            </div>
          </div>
        </div>
      )}
      {showResult && (
        <div className="text-center">
          <div
            className={`${isMobile() ? 'w-full px-2 text-2xl' : 'w-[926px] text-5xl'} text-center justify-center text-neutral-900 font-medium font-['Bitter']`}
          >
            {t('emailUnsubscribe.resultTitle')}
          </div>
          <div
            className={`${isMobile() ? 'w-full px-4 text-sm' : 'w-[926px] text-xl'} mt-3 text-center justify-center text-neutral-500 font-normal font-['DM_Sans'] leading-loose`}
          >
            {t('emailUnsubscribe.resultDesc')}
          </div>
        </div>
      )}
    </div>
  );
}
